import { Observable } from "rxjs";

export abstract class NotificationsService {
  init: () => Promise<void>;
  updateConnection: (sync?: boolean) => Promise<void>;
  reconnectFromActivity: () => Promise<void>;
  disconnectFromInactivity: () => Promise<void>;
  referralCreditAwarded$?: Observable<void>;
  /** Emits the request id whenever another device asks this account to approve it (TDE). */
  deviceApprovalRequested$?: Observable<string>;
}
